import React              from 'react'
import ImagePcbNoon       from 'images/pcb_noon.svg'

import { useWindowHook }  from 'pu-utils/windowHook'

export default () => {

  const { windowWidth } = useWindowHook()

  return (
    <div className="row usa-notes pt-3">
      <div className="col-md-6">
        <div className="row g-0">
          <div className="col-6 col-sm-6">
            <strong>Cutoff Times (PST)</strong>
          </div>
          <div className="col-3 col-sm-3">
            <span className="cutoff-noon">Noon <img src={ImagePcbNoon} alt="" /></span>
          </div>
          <div className="col-3 col-sm-3">
            <span>5:00 p.m.</span>
          </div>
        </div>
      </div>
    </div>
  )
}
